import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isTrustedShellOrigin } from '../constants/origins';

export function useIframeNavigationSync(): void {
  const location = useLocation();
  const navigate = useNavigate();
  const isInIframe = window.self !== window.top;

  useEffect(() => {
    if (!isInIframe) return;
    const path = location.pathname + location.search + (location.hash || '');
    window.parent.postMessage({ type: 'IFRAME_NAVIGATE', path }, '*');
  }, [location, isInIframe]);

  useEffect(() => {
    if (!isInIframe) return;

    const handler = (e: MessageEvent) => {
      if (!isTrustedShellOrigin(e.origin)) return;

      if (e.data?.type === 'BIZTADA_NAVIGATE') {
        const path = e.data.path as string;
        if (typeof path === 'string' && path.startsWith('/')) {
          navigate(path, { replace: true });
        }
        return;
      }

      if (e.data?.type === 'BIZTADA_REQUEST_PATH') {
        const path = location.pathname + location.search + (location.hash || '');
        window.parent.postMessage({ type: 'IFRAME_NAVIGATE', path }, '*');
      }
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [navigate, location, isInIframe]);
}
